"use client";

import { useState } from "react";
import { AppImage } from "@/components/ui/AppImage";

export function BeforeAfter({
  beforeImageId,
  beforeAlt,
  afterImageId,
  afterAlt,
  caption,
}: {
  beforeImageId: string;
  beforeAlt: string;
  afterImageId: string;
  afterAlt: string;
  caption: string;
}) {
  const [position, setPosition] = useState(50);

  return (
    <figure className="m-0">
      <div className="relative aspect-[3/2] overflow-hidden rounded-sm border border-paper/20 has-[input:focus-visible]:outline-2 has-[input:focus-visible]:outline-paper has-[input:focus-visible]:outline-offset-2">
        <AppImage
          fill
          imageId={afterImageId}
          alt={afterAlt}
          width={3}
          height={2}
          sizes="(min-width: 1024px) 46vw, 100vw"
        />

        <div
          className="absolute inset-0"
          style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
        >
          <AppImage
            fill
            imageId={beforeImageId}
            alt={beforeAlt}
            width={3}
            height={2}
            sizes="(min-width: 1024px) 46vw, 100vw"
          />
        </div>

        {/* Dělící linka s úchytem */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-y-0 w-px bg-paper"
          style={{ left: `${position}%` }}
        >
          <span className="absolute top-1/2 left-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-paper bg-ink">
            <span className="flex items-center gap-0.5 text-paper">
              <Chevron direction="left" />
              <Chevron direction="right" />
            </span>
          </span>
        </div>

        <span className="pointer-events-none absolute left-4 top-4 rounded-xs bg-ink/70 px-2 py-1 font-sans text-xs font-medium text-paper">
          Před
        </span>
        <span className="pointer-events-none absolute right-4 top-4 rounded-xs bg-ink/70 px-2 py-1 font-sans text-xs font-medium text-paper">
          Po
        </span>

        <input
          type="range"
          min={0}
          max={100}
          step={5}
          value={position}
          onChange={(event) => setPosition(Number(event.target.value))}
          aria-label="Porovnání stavu před a po renovaci"
          className="absolute inset-0 h-full w-full cursor-ew-resize appearance-none bg-transparent opacity-0 active:cursor-grabbing focus-visible:opacity-0"
        />
      </div>

      <figcaption className="mt-4 font-sans text-xs text-paper/70">
        {caption}
      </figcaption>
    </figure>
  );
}

function Chevron({ direction }: { direction: "left" | "right" }) {
  return (
    <svg
      aria-hidden="true"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {direction === "left" ? (
        <polyline points="15 18 9 12 15 6" />
      ) : (
        <polyline points="9 18 15 12 9 6" />
      )}
    </svg>
  );
}
